<template>
	<div>
		<van-sticky>
			<div class="rcst_sc">
				<div class="rcst_sc_drop">
					<div @click="backPrev()" class="rcst_sc_drop_left">
						<img src="../demo1/source/back.png" alt="" />
					</div>
					<van-dropdown-menu active-color="#FB8027">
						<van-dropdown-item v-model="cur_city" @change="selectDropdown" :options="cur_city_list" />
					</van-dropdown-menu>
				</div>
				<!-- <div class="rcst_date">
					<div v-for="(std_item,std_index) in date_list" :key="std_item.timp"
						:class="[{'rcst_date_itemS':date_index==std_index},'rcst_date_item']"
						@click="selectSportTypeDate(std_index)">
						<div>
							<div class="rcst_date_item_1">{{std_item.week_show}}</div>
							<div class="rcst_date_item_2">{{std_item.date}}</div>
						</div>
					</div>
				</div> -->
			</div>
		</van-sticky>

		<div class="spl">
			<div v-for="(st_item,st_index) in venus_list" :key="st_item.goodsId" @click="toDetail(st_item)"
				class="spl_block">
				<div class="spl_block_pic" >
					<!-- :style="'background-image: url('+st_item.thumb+');'" -->
					<van-image fit="cover" class="spl_block_pic_img" :src="st_item.thumb"/>
				</div>
				<div class="spl_block_block">
					<div class="spl_block_block_title">{{st_item.goods_name}}</div>
					<div class="spl_block_block_stitle">{{st_item.venue_name}}</div>
					<div class="spl_block_block_distance">{{st_item.district}}</div>
					<div class="spl_block_block_cont_btn">立即预约</div>
				</div>
				<!-- <div v-else class="spl_block_block">
					<div class="spl_block_block_title">{{st_item.venueName}}</div>
					<div class="spl_block_block_distance">{{st_item.district}}</div>
					<div class="spl_block_block_cont_btn">查看更多</div>
				</div> -->
			</div>
		</div>

	</div>
</template>

<script>
	import {
		futureTimesGroup,
	} from "../../lib/utils.js"
	export default {
		data() {
			return {
				cur_city: '',
				cur_city_list: [],

				date_list: futureTimesGroup(7),
				date_index: 0,

				venus_list: [],
				class_id:''
			}
		},
		created() {
			// console.log(this.$route.params.class_id);
			this.class_id=this.$route.params.class_id
			if(this.$route.params.class_id==1101){
				document.title='五星酒店游泳健身'
			}else if(this.$route.params.class_id==1901){
				document.title='五星酒店SPA'
			}else if(this.$route.params.class_id==1702){
				document.title='连锁健身房'
			}

			this.getCity()
		},
		mounted() {},
		methods: {
			backPrev(){
				this.$router.go(-1)
			},
			getCity() {
				this.$loading('正在加载中...');
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.demo1_cityList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						var cur_city = res.data[0]
						var cur_city_list = []
						res.data.map((item) => {
							var param = {
								text: item,
								value: item
							}
							cur_city_list.push(param)
						})
						if(localStorage.getItem('cur_city')){
							$this.cur_city =localStorage.getItem('cur_city')
						}else{
							$this.cur_city = res.data[0]
						}
						
						$this.cur_city_list = cur_city_list
						$this.getVenusList()
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			},
			getVenusList() {
				var $this = this
				var param = {
					class_id: this.class_id,
					city: this.cur_city,
					page: 1,
					page_size: 9999999
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_getVenueGoodsList
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						$this.venus_list = res.data
						$this.$loading.close();
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			},
			toDetail(item) {
				this.$router.push({
					name: 'venue_goods_detail',
					params: {
						goodsId: item.goods_id,
						index: this.date_index
					}
				})
			},
			// 
			selectSportTypeDate(e) {
				this.date_index = e
			},
			selectDropdown(e) {
				// console.log(e);
				localStorage.setItem('cur_city',e)
				this.cur_city = e
				this.getVenusList()
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		// padding: 0 0 20*@vm_base 0;
		background-color: #fff;

		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;
			padding: 0 30*@vm_base;
			// border: 1*@vm_base solid red;
			.rcst_sc_drop_left{
				width: 60*@vm_base;
				height: 100%;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				img{
					width: 36*@vm_base;
				}
			}
		}

		.rcst_date {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 30*@vm_base;
		}

		.rcst_date_item {
			width: 80*@vm_base;
			height: 92*@vm_base;
			border-radius: 16*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			color: #666666;
			border: 1*@vm_base solid #fff;
		}

		.rcst_date_itemS {
			border: 1*@vm_base solid #F77F28;
			color: #F77F28;
		}

		.rcst_date_item_1 {
			font-size: 20*@vm_base;
		}

		.rcst_date_item_2 {
			font-weight: bold;
			font-size: 30*@vm_base;
			margin-top: 6*@vm_base;
		}
	}

	.spl {
		width: 100%;
		background-color: #FFFFFF;
		padding: 2*@vm_base 30*@vm_base 20*@vm_base 30*@vm_base;
		color: #000;

		.spl_block {
			width: 100%;
			background: rgba(246, 247, 249, 1);
			border-radius: 16*@vm_base;
			margin-bottom: 20*@vm_base;
		}

		.spl_block:last-child {
			margin-bottom: 0;
		}

		.spl_block_pic {
			width: 100%;
			
			border-radius: 16*@vm_base 16*@vm_base 0 0;
			background-position: top center;
			background-repeat: no-repeat;
			background-size:auto 100%;
			position: relative;
			overflow: hidden;
			.spl_block_pic_img{
				width: 100%;
				height: 414*@vm_base;
			}
		}

		/* .spl_block_pic_bvip{
		  width: fit-content;
		  white-space: nowrap;
		  height: 50*@vm_base;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  padding: 0 20*@vm_base;
		  background: linear-gradient( 90deg, #FAE9D2 0%, #F3CFA6 100%);
		  border-radius:0 0 16*@vm_base 0;
		  font-size: 26*@vm_base;
		  color: #333333;
		} */
		.spl_block_pic_logo {
			position: absolute;
			top: 0;
			right: 0;
			width: 80*@vm_base;
			height: 80*@vm_base;
			margin-top: 20*@vm_base;
			margin-right: 20*@vm_base;
		}

		.spl_block_pic_recomm {
			position: absolute;
			bottom: 0;
			left: 0;
			padding: 20*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.spl_block_pic_recomm_item {
			width: fit-content;
			margin-right: 20*@vm_base;
			font-weight: 500;
			font-size: 20*@vm_base;
			color: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.spl_block_pic_recomm_item_cricle {
			width: 40*@vm_base;
			height: 40*@vm_base;
			background: rgba(255, 255, 255, 0.4);
			border-radius: 50%;
			margin-right: 6*@vm_base;
			background-size: 26*@vm_base;
			background-repeat: no-repeat;
			background-position: center;
		}

		.spl_block_pic_recomm_item_cricle_hot {
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240409_BUCoPFs538RkXOD.png);
		}

		.spl_block_pic_recomm_item_cricle_rec {
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240409_i4DXiGJB32TKUpu.png);
		}

		.spl_block_block {
			width: 100%;
			padding: 30*@vm_base 20*@vm_base 20*@vm_base 20*@vm_base;
			position: relative;
		}

		.spl_block_block_title {
			width: calc(100% - 200*@vm_base);
			font-weight: 600;
			font-size: 36*@vm_base;
			color: #333333;
			line-height: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.spl_block_block_stitle{
			width: calc(100% - 200*@vm_base);
			font-size: 28*@vm_base;
			color: #999999;
			line-height: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			margin-top: 20*@vm_base;
		}

		.spl_block_block_distance {
			width: 100%;
			margin-top: 20*@vm_base;
			font-size: 24*@vm_base;
			color: #999999;
			line-height: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			padding-left: 36*@vm_base;
			background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240529_m6K3irKkqOLCOKu.png);
			background-size: auto 98%;
			background-position: left bottom;
			background-repeat: no-repeat;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.spl_block_block_distance view {
			width: 200*@vm_base;
			text-align: center;
			color: #FF4600;
		}

		.spl_block_block_cont {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-top: 6*@vm_base;
		}

		.spl_block_block_cont_btn {
			position: absolute;
			bottom: 30*@vm_base;
			right:30*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 200*@vm_base;
			height: 64*@vm_base;
			background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 32*@vm_base;
			font-weight: 500;
			font-size: 30*@vm_base;
			color: #FFFFFF;
		}

		.spl_block_block_cont_btnN {
			background: rgba(0, 0, 0, 0.4);
		}

		.spl_block_block_cont_price {
			display: flex;
			justify-content: center;
			align-items: flex-end;
		}

		.spl_block_block_cont_price_1 {
			/* font-weight: 500; */
			font-size: 24*@vm_base;
			color: #F77F28;
			line-height: 1.5;
		}

		.spl_block_block_cont_price_2 {
			/* font-weight: 500; */
			font-size: 52*@vm_base;
			color: #F77F28;
			line-height: 1;
		}

		.spl_block_block_cont_price_3 {
			/* font-weight: 500; */
			font-size: 24*@vm_base;
			color: #F77F28;
			line-height: 1.5;
		}

		.spl_block_block_cont_price_4 {
			/* font-weight: 500; */
			font-size: 24*@vm_base;
			color: #999999;
			line-height: 1.5;
			margin-left: 20*@vm_base;
			text-decoration: line-through;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/list.vue